// extracted by mini-css-extract-plugin
export var lg = "_2a-4";
export var md = "_2a-3";
export var sm = "_2a-2";
export var xs = "_2a-1";
export var xxs = "_2a-0";